<template>
	<div name="hrms15e-popup3-desc2" id="hrms15e-popup3-desc2" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
		  <div class="modal-content">
		    <div class="modal-header header-popup">
		      <button type="button" class="close" data-dismiss="modal">&times;</button>
		      <h4 class="modal-title">{{ labels['HRAP31EC9']['10'] }}</h4>
		    </div>

		    <div class="modal-body detail detail-responsive">
					<div class="box-body">
						<form class="form-horizontal">
		          <div class="form-group margin-b-5">
		            <label class="col-md-3 control-label">{{ labels['HRAP31EC9']['20'] }}</label>
		            <div class="col-md-2">
		              <div class="form-control readonly-field-color">{{ setYearOutput(data.detail.dteyreap) }}</div>
		            </div>
		            <label class="col-md-2 control-label">{{ labels['HRAP31EC9']['30'] }}</label>
		            <div class="col-md-2">
		              <div class="form-control readonly-field-color">{{ data.detail.numtime }}</div>
		            </div>
		          </div>
		        </form>
						<form class="form-horizontal">
		          <div class="form-group margin-b-5">
		            <label class="col-md-3 control-label">{{ labels['HRAP31EC9']['50'] }}</label>
		            <div class="col-md-6">
		              <div class="form-control readonly-field-color">{{ data.detail.kpino }}</div>
		            </div>
		          </div>
		        </form>
						<form class="form-horizontal">
		          <div class="form-group margin-b-5">
		            <label class="col-md-3 control-label">{{ labels['HRAP31EC9']['40'] }}</label>
		            <div class="col-md-6">
		              <div class="form-control readonly-field-color">{{ data.detail.codempid }} - {{ data.detail.desc_codempid }}</div>
		            </div>
		          </div>
		        </form>
						<form class="form-horizontal">
		          <div class="form-group margin-b-5">
		            <label class="col-md-3 control-label">{{ labels['HRAP31EC9']['60'] }}</label>
		            <div class="col-md-6">
		              <textarea  class="form-control readonly-field-color" readonly>{{ data.detail.kpiitem }}</textarea> 
		            </div>
		          </div>
		        </form>
						<form class="form-horizontal">
		          <div class="form-group margin-b-5">
		            <label class="col-md-3 control-label">{{ labels['HRAP31EC9']['70'] }}</label>
		            <div class="col-md-6">
		              <textarea  class="form-control readonly-field-color" readonly>{{ data.detail.target }}</textarea> 
		            </div>
		          </div>
		        </form>
		        <form class="form-horizontal">
		          <div class="form-group margin-b-5">
		            <label class="col-md-3 control-label">{{ labels['HRAP31EC9']['80'] }}</label>
		            <div class="col-md-2">
		              <div class="form-control readonly-field-color">{{ data.detail.v_mtrunit }}</div>
		            </div>
		            <label class="col-md-2 control-label">{{ labels['HRAP31EC9']['90'] }}</label>
		            <div class="col-md-2">
		              <div class="form-control readonly-field-color">{{ data.detail.mtrvalue }}</div>
		            </div>
		          </div>
		        </form>

						<hrms-table :columns="detail3InfoDesc2PopupTable" 
                    		:data="data.table"
                    		:indexDisp="false"
                    		:searchDisp="false" />
					
					</div>
				</div>
		  </div>
		</div>
	</div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hrms15e-popup3-desc2',
  data () {
    return {
      selectedRow: []
    }
  },
  props: [ 'labels', 'data', 'detail3InfoDesc2PopupTable' ],
  methods: {
    setYearOutput (date) {
      return assetsUtils.getYearOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// popupDetail3InfoDesc2.vue?07f27057